import React from 'react';

import { Button, Group, Title } from '@mantine/core';
import Drawer from 'components/Drawer';
import LogWorkForm from 'components/LogWorkForm';

interface IDrawerLogWorkFormProps {
  opened: boolean;
  onClose: () => void;
}

const FORM_ID = 'log-work-form';

const DrawerLogWorkForm = ({ opened, onClose }: IDrawerLogWorkFormProps): JSX.Element => {
  const handleSubmitSuccess = (): void => {
    onClose();
  };

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      size='lg'
      title={<Title order={3}>Log Work Hours</Title>}
      footer={
        <Group position='right'>
          <Button variant='subtle' onClick={onClose}>
            Cancel
          </Button>
          <Button form={FORM_ID} type='submit'>
            Save
          </Button>
        </Group>
      }
    >
      <LogWorkForm formId={FORM_ID} hideSubmitButton onSubmitSuccess={handleSubmitSuccess} />
    </Drawer>
  );
};

export default DrawerLogWorkForm;
